"use strict";

var _classCallCheck = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _types = require("./types");
var _Coordinator = _interopRequireDefault(require("./Coordinator"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// Copyright (c) 2017 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var LayoutManager = /*#__PURE__*/function () {
  function LayoutManager(options) {
    var _this = this;
    _classCallCheck(this, LayoutManager);
    this.layoutId = void 0;
    this.coordinator = void 0;
    this.pendingResult = void 0;
    this.options = void 0;
    this._handleUpdate = function (data) {
      var pendingResult = _this.pendingResult;
      if (!pendingResult || data.layoutId !== pendingResult.id) {
        return;
      }
      if (data.type === _types.ECoordinatorPhase.Positions) {
        var isPositionsResolved = pendingResult.isPositionsResolved,
          resolvePositions = pendingResult.resolvePositions;
        if (isPositionsResolved) {
          // eslint-disable-next-line no-console
          console.warn('Duplicate positiosn update', data);
          return;
        }
        var graph = data.graph,
          vertices = data.vertices;
        if (!vertices || !resolvePositions) {
          // make flow happy
          throw new Error('Invalid state');
        }
        pendingResult.isPositionsResolved = true;
        resolvePositions({
          graph: graph,
          vertices: vertices,
          isCancelled: false
        });
      } else if (data.type === _types.ECoordinatorPhase.Done) {
        var resolveLayout = pendingResult.resolveLayout;
        var edges = data.edges,
          _graph = data.graph,
          _vertices = data.vertices;
        if (!edges || !_vertices || !resolveLayout) {
          // make flow happy
          throw new Error('Invalid state');
        }
        _this.pendingResult = null;
        resolveLayout({
          edges: edges,
          graph: _graph,
          vertices: _vertices,
          isCancelled: false
        });
      } else {
        throw new Error('Unrecognized update type');
      }
    };
    this.options = options;
    this.layoutId = 0;
    this.coordinator = new _Coordinator.default(this._handleUpdate);
    this.pendingResult = null;
  }
  _createClass(LayoutManager, [{
    key: "getLayout",
    value: function getLayout(edges, vertices) {
      var _this2 = this;
      this._cancelPending();
      this.layoutId++;
      var id = this.layoutId;
      this.coordinator.getLayout(id, edges, vertices, this.options);
      this.pendingResult = {
        id: id,
        isPositionsResolved: false
      };
      var positions = new Promise(function (resolve) {
        if (_this2.pendingResult && id === _this2.pendingResult.id) {
          _this2.pendingResult.resolvePositions = resolve;
        }
      });
      var layout = new Promise(function (resolve) {
        if (_this2.pendingResult && id === _this2.pendingResult.id) {
          _this2.pendingResult.resolveLayout = resolve;
        }
      });
      return {
        layout: layout,
        positions: positions
      };
    }
  }, {
    key: "stopAndRelease",
    value: function stopAndRelease() {
      this._cancelPending();
      this.coordinator.stopAndRelease();
    }
  }, {
    key: "_cancelPending",
    value: function _cancelPending() {
      var pending = this.pendingResult;
      if (pending) {
        if (!pending.isPositionsResolved && pending.resolvePositions) {
          pending.resolvePositions({
            isCancelled: true
          });
          pending.isPositionsResolved = true;
        }
        if (pending.resolveLayout) {
          pending.resolveLayout({
            isCancelled: true
          });
        }
        this.pendingResult = null;
      }
    }
  }]);
  return LayoutManager;
}();
exports.default = LayoutManager;